export default function themeReducer(theme = "default") {
	return theme;
}
